const defaultProperties = {
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: {
    show: false,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  text: 'Shop Now',
  link: '#',
  show: true,
  subBtn: {
    show: false,
    text: '30-Day Money-Back Guararantee',
  },
};

export default (properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  return `
    <div data-attribute="wrap-button" data-show="${finalProperties.show ? 'true' : 'false'}" class="wrap-button">
      <a data-show="${finalProperties.show ? 'true' : 'false'}" href="${
    finalProperties.link
  }" data-attribute="btn-link" data-background="${finalProperties.backgroundColor}" data-color="${
    finalProperties.color
  }" data-radius="${finalProperties.radius}"
      class="btn-link" style="background-color: ${finalProperties.backgroundColor}!important; color: ${
    finalProperties.color
  }!important; border-radius: ${finalProperties.radius}px;">
          <span data-show="${
            finalProperties.iconPrefix.show ? 'true' : 'false'
          }" data-attribute="icon-prefix" class="icon-prefix" style="${
    finalProperties.iconPrefix.show ? '' : 'display: none;'
  }">
              <img data-attribute="icon-prefix-image"
              src="${finalProperties.iconPrefix.src}" alt="">
          </span>
          <span data-attribute="text-btn" class="text-btn">${finalProperties.text}</span>
          <span data-show="${
            finalProperties.iconSuffix.show ? 'true' : 'false'
          }" data-attribute="icon-suffix" class="icon-suffix" style="${
    finalProperties.iconSuffix.show ? '' : 'display: none;'
  }">
              <img data-attribute="icon-suffix-image"
              src="${finalProperties.iconSuffix.src}"
              alt="">
          </span>
      </a>
      <div data-show="${finalProperties.subBtn.show ? 'true' : 'false'}" data-attribute="sub-btn" class="sub-btn">
        ${finalProperties.subBtn.text}
      </div>
    </div>
      `;
};
